import { Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import React, { FC } from 'react';

interface IPageTitle {
  title?: string;
  marginOff?: boolean;
  centerHeader?: boolean;
}

export const PageTitle: FC<IPageTitle> = ({ centerHeader, title, marginOff = false }) => {
  const classes = useStyles({ marginOff });

  return (
    <Typography
      className={`${classes.header} ${centerHeader ? classes.centerHeader : ''}`}
      variant="h6"
    >
      {title}
    </Typography>
  );
};

const useStyles = makeStyles<Theme, IPageTitle>(theme => ({
  header: {
    color: theme.palette.primary.main,
    fontWeight: 600,
    marginBottom: ({ marginOff }) => (marginOff ? 0 : theme.spacing(2)),
  },
  centerHeader: {
    display: 'flex',
    justifyContent: 'center',
  },
}));
